import { ref, watch, computed, nextTick, getCurrentInstance } from 'vue';
import { useJumpToFirstError } from '../../../common/js/composables/jump-to-first-error';
import bookAppointmentApi from '../../../api/bookappointment-api';
const REQUEST_STATES = {
	INITIAL: 'INITIAL',
	LOADING: 'LOADING',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR'
};
export const useCaptcha = (captchaError) => {
	const { jumpToFirstError } = useJumpToFirstError(getCurrentInstance());
	const requestState = ref(REQUEST_STATES.INITIAL);
	const captchaKey = ref(null);
	const captchaImg = ref(null);
	const getCaptcha = async () => {
		try {
			requestState.value = REQUEST_STATES.LOADING;
			captchaKey.value = null;
			captchaImg.value = null;

			const { data } = await bookAppointmentApi.init();
			captchaKey.value = data.captchaDTO.captchaToken;
			captchaImg.value = data.captchaDTO.htmlFragment;
			requestState.value = REQUEST_STATES.INITIAL;
		} catch (err) {
			requestState.value = REQUEST_STATES.TECHNICAL_ERROR;
		}
	};
	watch(captchaError, (val) => {
		if (val) {
			getCaptcha();
		}
	});
	watch(captchaImg, async (value) => {
		if (value && captchaError.value) {
			await nextTick();
			jumpToFirstError();
		}
	});

	const technicalError = computed(() => requestState.value == REQUEST_STATES.TECHNICAL_ERROR);
	const loading = computed(() => requestState.value == REQUEST_STATES.LOADING);

	return {
		technicalError,
		captchaImg,
		captchaKey,
		loading,
		getCaptcha
	};
};
